import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import Alert from '@mui/material/Alert';

export default function CancelDeployment({
  deployment,
  onCancelSuccess,
  onCancelFailure,
}) {
  const handleSuccess = () => {
    onCancelSuccess();
  };

  return (
    <Dialog
      open={true}
      onClose={onCancelFailure}
      PaperProps={{
        sx: {
          borderRadius: 2,
          minWidth: { xs: '90%', sm: '500px' },
        },
      }}
    >
      <DialogContent>
        <Box sx={{ textAlign: 'center', py: 2 }}>
          <Typography
            variant="h5"
            gutterBottom
            sx={{
              fontWeight: 500,
              color: 'error.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
            }}
          >
            <WarningIcon />
            Deployment kündigen
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 2 }}>
            &quot;{deployment?.title || 'Unbenannt'}&quot;
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography sx={{ mb: 2 }}>
            Sind Sie sicher, dass Sie dieses Deployment kündigen möchten?
          </Typography>

          <Alert
            severity="warning"
            sx={{
              mx: 'auto',
              mb: 2,
              textAlign: 'left',
              '& .MuiAlert-message': {
                width: '100%',
              },
            }}
          >
            <Typography variant="subtitle2" sx={{ fontWeight: 500, mb: 1 }}>
              Bitte beachten Sie:
            </Typography>
            <ul style={{ margin: 0, paddingLeft: '1.5rem' }}>
              <li>
                Alle Benutzer verlieren sofort ihren Zugriff auf dieses
                Deployment
              </li>
            </ul>
          </Alert>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onCancelFailure}
          variant="outlined"
          sx={{ minWidth: 100 }}
        >
          Abbrechen
        </Button>
        <Button
          onClick={handleSuccess}
          color="error"
          variant="contained"
          autoFocus
          sx={{ minWidth: 100 }}
        >
          Kündigen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
